import type { SkillFileNode } from '@onefootprint/request-types/dashboard';

const readFileEntry = (entry: FileSystemFileEntry): Promise<File> =>
  new Promise((resolve, reject) => entry.file(resolve, reject));

const readDirectoryEntries = (reader: FileSystemDirectoryReader): Promise<FileSystemEntry[]> =>
  new Promise((resolve, reject) => reader.readEntries(resolve, reject));

const readEntry = async (entry: FileSystemEntry): Promise<SkillFileNode> => {
  if (entry.isFile) {
    const file = await readFileEntry(entry as FileSystemFileEntry);
    const content = await file.text();
    return { kind: 'file', name: entry.name, content };
  }
  const dirReader = (entry as FileSystemDirectoryEntry).createReader();
  const children: SkillFileNode[] = [];
  let batch = await readDirectoryEntries(dirReader);
  while (batch.length > 0) {
    for (const child of batch) {
      children.push(await readEntry(child));
    }
    batch = await readDirectoryEntries(dirReader);
  }
  return { kind: 'folder', name: entry.name, children };
};

const readDroppedItems = async (items: DataTransferItemList): Promise<SkillFileNode[]> => {
  const nodes: SkillFileNode[] = [];
  for (const item of Array.from(items)) {
    const entry = item.webkitGetAsEntry?.();
    if (entry) {
      nodes.push(await readEntry(entry));
    }
  }
  return nodes;
};

export default readDroppedItems;
